import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import NotificationService from "@/services/Notification/notification.service";
import type { NotificationItem } from "@/shared/types/Notifications";

export const  NOTIFICATIONS_QUERY_KEY = ["notifications"] as const;

export const useNotifications = () => {
  return useQuery<NotificationItem[]>({
    queryKey: NOTIFICATIONS_QUERY_KEY,
    queryFn: () => NotificationService.getUserNotifications(),
    staleTime: 60_000,
  });
};

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => NotificationService.markAsRead(id),
    onSuccess: (_data, id) => {
      queryClient.setQueryData<NotificationItem[]>(
        NOTIFICATIONS_QUERY_KEY,
        (prev) =>
          (prev ?? []).map((n) =>
            n.id === id ? { ...n, isRead: true } : n
          )
      );
    },
  });
};

export const useDeleteNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => NotificationService.delete(id),
    onSuccess: (_data, id) => {
      queryClient.setQueryData<NotificationItem[]>(
        NOTIFICATIONS_QUERY_KEY,
        (prev) => (prev ?? []).filter((n) => n.id !== id)
      );
    },
  });
};